import { Component, OnInit, Input } from '@angular/core';

declare var $: any
@Component({
  selector: 'app-event-register-details',
  templateUrl: './event-regiser-details.component.html',
  styleUrls: ['./event-regiser-details.component.less']
})
export class EventRegiserDetailsComponent implements OnInit {
  @Input('details') details: any;

  constructor() { }

  ngOnInit() {
  }

  openStatus() {
    $("#eventStatus").modal('show');
  }

  bookedData(data){
    this.details.is_approved = data.is_approved,
    this.details.room_amount = data.room_amount,
    this.details.admin_remarks = data.admin_remarks
  }

}
